import { graphql } from "@/gql";

export const userRecordQuery = graphql(`
  query UserRecord($id: ID!) {
    user(id: $id) {
      ...UserFields
    }
  }
`);

export const userRecordFields = graphql(`
  fragment UserFields on User {
    id
    name
    primary_email
    primary_phone
    date_of_birth
    email_undeliverable_at
    email_undeliverable_reason
    updated_at
    created_at
    profilePicture {
      ...MediaFields
    }
    contact {
      id
      name
      billing_email
      billing_phone
    }
    notificationSettings {
      id
      gets_email_notifications
    }
  }
`);
